var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "normal-table" },
    [
      _c("div", { staticClass: "table-head" }, [
        _vm._v(_vm._s(_vm.normalTableconfig.title)),
      ]),
      _vm._v(" "),
      _c("Table", {
        class: {
          orange: _vm.normalTableconfig.orange,
          blue: _vm.normalTableconfig.blue,
          green: _vm.normalTableconfig.green,
        },
        attrs: {
          border: "",
          columns: _vm.normalTableconfig.columns,
          data: _vm.normalTableconfig.data,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }